module.exports = "th {\n  font-size: 12px;\n  font-weight: 700;\n  color: #555;\n}\n"